// Official UTMify UTM tracking script
// <script src="https://cdn.utmify.com.br/scripts/utms/latest.js" data-utmify-prevent-xcod-sck data-utmify-prevent-subids async defer></script>
export function loadUtmify(): void {
  if (typeof document === 'undefined') return;
  if (document.querySelector('script[src="https://cdn.utmify.com.br/scripts/utms/latest.js"]')) return;

  const script = document.createElement('script');
  script.src = 'https://cdn.utmify.com.br/scripts/utms/latest.js';
  script.setAttribute('data-utmify-prevent-xcod-sck', '');
  script.setAttribute('data-utmify-prevent-subids', '');
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
}
